import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';

// Import hooks
import { useNavigationButtons } from './useNavigationButtons';

// Import styles
import { Container } from './styles';

// Import components
import { Button } from 'components/elements/atoms/Button/Button';

type Props = {
	disabled: boolean;
	formId?: string;
	fullWidth?: boolean;
	children?: ReactNode;
};

export const NavigationButtons = ({ disabled, formId, fullWidth = true, children }: Props) => {
	const { t } = useTranslation('configurator');
	const { activeStep, isLastStep, handleNavigate } = useNavigationButtons();

	const buttonType = formId ? 'submit' : 'button';
	const onClick = !formId ? handleNavigate(1) : undefined;

	return (
		<>
			{isLastStep && children}

			<Container fullWidth={fullWidth}>
				{activeStep !== 0 && (
					<Button onClick={handleNavigate(-1)} disabled={disabled} type="button" variant="secondary" modifiers={['outlined']}>
						{t('button_back')}
					</Button>
				)}
				<Button disabled={disabled} onClick={onClick} type={buttonType} form={formId} variant="primary" modifiers={['contained']}>
					{t('button_further')}
				</Button>
			</Container>
		</>
	);
};
